<template>
  <Icon>
    <svg slot="svg" :class="$style['icon']" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 C13.1045695,10 14,10.8954305 14,12 Z M14,5 C14,6.1045695 13.1045695,7 12,7 C10.8954305,7 10,6.1045695 10,5 C10,3.8954305 10.8954305,3 12,3 C13.1045695,3 14,3.8954305 14,5 Z M14,19 C14,20.1045695 13.1045695,21 12,21 C10.8954305,21 10,20.1045695 10,19 C10,17.8954305 10.8954305,17 12,17 C13.1045695,17 14,17.8954305 14,19 Z" id="path-1"></path>
      </defs>
      <g id="icons/Overflow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2" fill="white">
          <use xlink:href="#path-1"></use>
        </mask>
        <g id="Overflow" fill-rule="nonzero"></g>
        <g id="Mixin/Fill/Black" mask="url(#mask-2)" fill="#8390a5">
          <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsDotsIcon",
  components: {
    Icon
  }
};
</script>

<style class="scss" module>
.icon {
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-dots-icon.vue